<template>
  <section aria-label="menu de opciones de accesibilidad">
    <div class="menu-acces menubots text-xs-right">
      <ul>
        <li v-for="(bot, index) in listBots" :key="index">
          <button tabindex="1" @click.stop="bot.clickBot" class="hvr-grow botbor" :aria-label="bot.name" :class="('bot-'+index)"></button>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      size: 100,
      listBots: [
        { name: "Reducir tamaño de letra", clickBot: this.reduceText },
        { name: "Aumentar tamaño de letra", clickBot: this.incrementText },
        { name: "Tamaño de letra por defecto", clickBot: this.defaultText },
        { name: "Cambiar de color", clickBot: this.changeColor }
      ]
    };
  },
  methods: {
    incrementText() {
      if (this.size < 200) {
        this.size += 25;
        document.getElementsByTagName("HTML")[0].style.fontSize =
          this.size + "%";
      }
    },
    defaultText() {
      this.size = 88;
      document.getElementsByTagName("HTML")[0].style.fontSize = this.size + "%";
    },
    reduceText() {
      if (this.size > 100) {
        this.size -= 25;
        document.getElementsByTagName("HTML")[0].style.fontSize =
          this.size + "%";
      }
    },
    changeColor() {
      this.$store.commit("changeColor");
    }
  },
  computed: {
    color() {
      return this.$store.state.color;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../sass/helpers/variables.scss";

.menu-acces {
  margin-top: 0px;
  position: fixed;
  border-radius: 5px;
  z-index: 50;
  right: 10px;
  li {
    display: inline-block;
    button {
      background-image: url("../../assets/logos-icons/access-buttons.png");
      background-color: #565656;
    }
  }
}

.dark {
  .bot-3 {
    background-position-y: -41.5px !important;
  }
  li {
    button {
      background-color: $secondary-red;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Accesmenu.vue?62bad578